/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { clone } from "lodash";

/* components */
import { Scope } from "informed";
import { get as _get } from "lodash";
import CollectionAccordion from "../../../../shared/Forms/CollectionAccordion";

import getReference from "../../../../../helpers/objectManipulation/getReference";
import buildReference from "../../../../../helpers/objectManipulation/buildReference";

class Collection extends Component {
	constructor(props) {
		super(props);
		let { properties } = props.property.items;
		let titleKey = null;
		let titleFound = false;
		Object.keys(properties).forEach(key => {
			if ((key.toLowerCase() === "name" || key.toLowerCase() === "title") && !titleKey && !titleFound) {
				titleFound = true;
				titleKey = key;
			} else if (properties[key].type.toLowerCase() === "text" && !titleKey) {
				titleKey = key;
			}
		});
		this.state = {
			count: 0,
			expandedIndex: null,
			titleKey: titleKey || "name",
		};
	}

	componentDidMount() {
		const { property, propertyKey, collectionPrefix, formApi } = this.props;
		let value = this.props.formApi.getValue(collectionPrefix + "." + propertyKey);
		let newValues = Object.assign({}, formApi.getState().values);
		let newRef = buildReference(newValues, `${collectionPrefix}.${propertyKey}`);
		let count = 0;
		if (value) {
			count = value.length;
		}
		if (property.items.minimum && property.items.minimum > count) {
			this.setState({
				count: property.items.minimum,
			});
			for (let i = count; i < property.items.minimum; i++) {
				newRef[i] = {};
			}
			formApi.setValues(newValues);
		} else if (count > 0) {
			this.setState({
				count: count,
			});
		}
	}

	addPropertySet(e, max, multiple) {
		e.preventDefault();
		const { formApi, propertyKey, collectionPrefix } = this.props;
		if (!max || this.state.count < max) {
			const newCount = this.state.count + 1 * multiple;
			this.setState({
				count: newCount,
			});

			//TODO Add in default values from module definition
			let newValues = Object.assign({}, formApi.getState().values);
			let newRef = buildReference(newValues, `${collectionPrefix}.${propertyKey}`);
			if (newRef) {
				newRef[this.state.count] = {};
				formApi.setValues(newValues);
			} else {
				formApi.setValue(`${collectionPrefix}.${propertyKey}`, [{}]);
			}

			setTimeout(() => {
				this.setState({
					expandedIndex: newCount - 1,
				});
			}, 200);
		}
	}

	toggleCollectionItem = expandedIndex => {
		if (expandedIndex === this.state.expandedIndex) {
			this.setState({ expandedIndex: null });
		} else {
			this.setState({ expandedIndex: expandedIndex });
		}
	};

	moveUp = index => {
		const { formApi, propertyKey, collectionPrefix } = this.props;
		let newValues = Object.assign({}, formApi.getState().values);
		let newRef = getReference(newValues, `${collectionPrefix}.${propertyKey}`);
		newRef[index - 1] = formApi.getValue(`${collectionPrefix}.${propertyKey}[${index}]`);
		newRef[index] = formApi.getValue(`${collectionPrefix}.${propertyKey}[${index - 1}]`);
		if (this.state.expandedIndex !== null) {
			this.toggleCollectionItem(index - 1);
		}
		formApi.setValues(newValues);
	};

	moveDown = index => {
		const { formApi, propertyKey, collectionPrefix } = this.props;
		let newValues = Object.assign({}, formApi.getState().values);
		let newRef = getReference(newValues, `${collectionPrefix}.${propertyKey}`);
		newRef[index + 1] = formApi.getValue(`${collectionPrefix}.${propertyKey}[${index}]`);
		newRef[index] = formApi.getValue(`${collectionPrefix}.${propertyKey}[${index + 1}]`);
		if (this.state.expandedIndex !== null) {
			this.toggleCollectionItem(index + 1);
		}
		formApi.setValues(newValues);
	};

	copyCollection = index => {
		const { formApi, propertyKey, collectionPrefix, property } = this.props;
		let newCount = this.state.count + 1;
		if (!property.items.maximum || property.items.maximum >= newCount) {
			let newValues = Object.assign({}, formApi.getState().values);

			this.setState({ count: newCount, expandedIndex: index + 1 });

			let newRef = getReference(newValues, `${collectionPrefix}.${propertyKey}`);

			// splice instead of loop (helps keep consistency since newCount is not 0 index based, but index is)
			const itemBeingDuplicated = clone(newRef[index]);
			newRef.splice(index, 0, itemBeingDuplicated);

			if (this.state.expandedIndex !== null) {
				this.toggleCollectionItem(index + 1);
			}

			formApi.setValues(newValues);
		}
	};

	deleteCollection = index => {
		const { formApi, propertyKey, collectionPrefix, property } = this.props;
		let newCount = this.state.count - 1;
		if (!property.items.maximum || property.items.minimum <= newCount) {
			let newValues = Object.assign({}, formApi.getState().values);
			let newRef = getReference(newValues, `${collectionPrefix}.${propertyKey}`);
			let refs = [...newRef.slice(0, index), ...newRef.slice(index + 1)];
			var r = _get(newValues, collectionPrefix);
			r[propertyKey] = refs;
			if (this.state.expandedIndex === index) {
				this.toggleCollectionItem(null);
			} else if (this.state.expandedIndex > index) {
				this.toggleCollectionItem(this.state.expandedIndex - 1);
			}
			formApi.setValues(newValues);
			this.setState({ count: newCount });
		}
	};

	render() {
		const { property, propertyKey, renderProperties, collectionPrefix } = this.props;
		const { titleKey } = this.state;
		const { maximum, multiple } = property.items;
		const multiplier = multiple ? multiple : 1;
		let scopes = [];
		for (var i = 0; i < this.state.count; i++) {
			let label = this.props.formApi.getValue(`${collectionPrefix}.${propertyKey}[${i}].${titleKey}`);
			if (!label || label === "") {
				label = "Item";
			}
			scopes.push(
				<Scope scope={`${propertyKey}[${i}]`} key={i}>
					<CollectionAccordion
						title={label}
						expanded={this.state.expandedIndex === i}
						index={i}
						toggleCollectionItem={this.toggleCollectionItem}
						moveUp={this.moveUp}
						moveDown={this.moveDown}
						copyCollection={this.copyCollection}
						deleteCollection={this.deleteCollection}
						totalCount={this.state.count}
					>
						<div className="collection-item-properties">
							{renderProperties(property.items.properties, `${collectionPrefix}.${propertyKey}[${i}]`)}
						</div>
					</CollectionAccordion>
				</Scope>
			);
		}

		return (
			<div>
				<div>
					<div
						className="btn-circle m-right"
						title="Add An Item"
						onClick={e => this.addPropertySet(e, maximum, multiplier)}
					>
						<i className="fal fa-plus icon"></i>
					</div>
					<h4 className="collection-title">{property.label}</h4>
				</div>
				<div className="collection-group">{scopes}</div>
			</div>
		);
	}
}

Collection.propTypes = {
	propertyKey: PropTypes.string,
	property: PropTypes.object,
	renderProperties: PropTypes.func,
	collectionPrefix: PropTypes.string,
	formApi: PropTypes.object,
};

export default Collection;
